import React from 'react';

type Props = {
  taskId: string;
  width: number; // ширина задачи для позиционирования правой точки
  onPointClick: (taskId: string, side: 'start' | 'end', cx: number, cy: number) => void;
};

const POINT_SIZE = 10;

const PointStyle: React.CSSProperties = {
  position: 'absolute',
  top: '50%',
  width: POINT_SIZE,
  height: POINT_SIZE,
  marginTop: -POINT_SIZE / 2,
  borderRadius: '50%',
  background: '#fff',
  border: '2px solid #555',
  cursor: 'pointer',
  zIndex: 10,
  boxSizing: 'border-box',
};

export const TaskConnectionPoints: React.FC<Props> = ({ taskId, width, onPointClick }) => {
  return (
    <>
      {/* Left Point (Start) */}
      <div
        style={{ ...PointStyle, left: -POINT_SIZE / 2 }}
        className="connection-point"
        onPointerDown={e => {
          e.stopPropagation(); // чтобы не сработал drag задачи
          onPointClick(taskId, 'start', e.clientX, e.clientY);
        }}
      />

      {/* Right Point (End) */}
      <div
        style={{ ...PointStyle, left: width - POINT_SIZE / 2 }}
        className="connection-point"
        onPointerDown={e => {
          e.stopPropagation();
          onPointClick(taskId, 'end', e.clientX, e.clientY);
        }}
      />
    </>
  );
};
